import type { SVGProps } from "react";
import { memo } from "react";
const EC2AutoScaling = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#C8511B" />
        <stop offset="100%" stopColor="#F90" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M68 39.005H56.632l5.579-5.594-1.404-1.408-7.703 7.724 7.703 7.723 1.404-1.407-5.034-5.048H68zM18.056 33.41l5.579 5.594H13v1.99h10.09l-5.034 5.048 1.405 1.407 7.701-7.723-7.701-7.724zM33.55 48.959h14.89V34.027h-14.89zm16.725-15.927h2.136v1.99h-1.985v2.987h1.985V40h-1.985v2.986h1.985v1.991h-1.985v2.987h1.985v1.99h-2.136a1.68 1.68 0 0 1-.842.846v2.141H47.45v-1.99h-2.978v1.99h-1.986v-1.99h-2.978v1.99h-1.985v-1.99h-2.978v1.99h-1.986V50.8a1.7 1.7 0 0 1-.842-.845H29.58v-1.991h1.986v-2.987H29.58v-1.99h1.986V40H29.58v-1.991h1.986v-2.986H29.58v-1.991h2.136a1.7 1.7 0 0 1 .842-.846v-2.14h1.986v1.99h2.978v-1.99h1.985v1.99h2.978v-1.99h1.986v1.99h2.978v-1.99h1.985v2.14c.375.17.674.471.842.846m-8.783 31.157V53.937h-1.986v10.252l-5.306-5.32-1.403 1.407L40.5 68l7.702-7.724-1.403-1.408zM34.2 21.132l-1.403-1.408L40.5 12l7.702 7.724-1.403 1.408-5.306-5.321v11.126h-1.986V15.811z"
      />
    </g>
  </svg>
);
const Memo = memo(EC2AutoScaling);
export default Memo;
